var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"list_datatable w-full"}},[_c('div',{staticClass:"vx-row mb-2"}),_c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full"},[_c('ItemsTable',{attrs:{"headers_prop":_vm.headers,"list_url_prop":`category/${_vm.$route.params.id}/items`,"loading":_vm.loading}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }